import React, { cloneElement, Children, Component } from 'react';
import styles from './Steps.scss'

export default class Step extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let classes = [styles.step];

    if(this.props.success) {
      classes.push(styles.success);
    }

    if(this.props.current) {
      classes.push(styles.current);
    }

    if(this.props.title) {
      classes.push(styles.hasTitle);
    }

    return (
      <div className={classes.join(' ')}>
        <span>
          {this.props.stepNumber}
        </span>
        { this.props.title && <h2 className={styles.title}>{this.props.title}</h2> }
      </div>
    );
  }
}
